import React from 'react';

const AccountSettingsHeader = () => {
  return (
    <div className="mt-5 md:mt-10">
      <h1 className="govuk-heading-xl">Account settings</h1>
      <p className="govuk-body">You can update your account settings below.</p>
    </div>
  );
};

export default AccountSettingsHeader;
